<template>
  <div class="loginbBody">
    <div class="loginDiv">
      <div class="login-content">
        <h1 class="login-title">用户登录</h1>
        <el-form
          :model="loginForm"
          label-width="100px"
          :rules="rules"
          @submit.native.prevent
          ref="loginForm"
        >
          <el-form-item label="账号：" prop="username" class="login_item">
            <el-input
              style="width: 200px"
              type="text"
              v-model="loginForm.username"
              autocomplete="off"
              size="small"
            ></el-input>
          </el-form-item>
          <el-form-item label="密码：" prop="password" class="login_item">
            <el-input
              style="width: 200px"
              type="password"
              v-model="loginForm.password"
              show-password
              autocomplete="off"
              size="small"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              class="login_btn"
              @click="login"
              native-type="submit"
              >登录</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import { login } from "@/utils/api";
export default {
  name: "login",
  data() {
    return {
      loginForm: {
        username: "",
        password: ""
      },
      rules: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" }
        ],
        password: [{ required: true, message: "请输密码", trigger: "blur" }]
      }
    };
  },
  mounted() {
    // 判断登录状态
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    if (null === userInfo) return;
    if (userInfo.token) {
      this.$router.push("/home");
    } else {
      return false;
    }
    window.addEventListener("keydown", this.keyDown);
  },

  methods: {
    // 登录
    login() {
      var that = this;
      let obj = {
        user_name: that.loginForm.username,
        user_password: that.loginForm.password
      };
      that.$refs.loginForm.validate(valid => {
        if (valid == true) {
          login(obj).then(res => {
            if (res.data.code == 1) {
              that.$message.success(res.data.msg);
              // 将登录状态存到vuex和localStorage中
              let userInfo = res.data.data;
              localStorage.setItem("userInfo", JSON.stringify(userInfo));
              this.$store.state.userInfo = userInfo;
              that.$router.push("/home");
            } else {
              that.$message.error(res.data.msg);
            }
          });
        }
      });
    },
    // 监听回车键执行事件
    keyDown(e) {
      // 回车则执行登录方法 enter键的ASCII是13
      if (e.keyCode === 13) {
        console.log("回车");
        this.login(); // 需要执行的方法方法
      }
    }
  },
  // 销毁事件
  destroyed() {
    window.removeEventListener("keydown", this.keyDown, false);
  }
};
</script>
<style scoped>
* {
  margin: 0;
  padding: 0;
}

.loginbBody {
  width: 100%;
  height: 100vh;
  background: linear-gradient(to right, #56ccf2, #2f80ed);
}
.loginDiv {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -200px;
  margin-left: -250px;
  width: 450px;
  height: 330px;
  background: #fff;
  box-shadow: #dee0e1 3px 3px 10px;
  border-radius: 5%;
}
@media screen and (max-width: 750px) and (min-width: 375px) {
  .loginDiv {
    width: 350px !important;
    height: 300px !important;
    left: 70% !important;
  }
  .login-content {
    left: -10px !important;
  }
  .login-title {
    font-size: 25px;
  }
}
.login-title {
  margin: 20px 0;
  text-align: center;
}
.login-content {
  width: 400px;
  height: 250px;
  position: absolute;
  top: 25px;
  left: 25px;
}
.login_btn {
  width: 50%;
  padding: 10px;
  margin-left: 20px;
  margin-top: 30px;
}
/* .loginbBody  .el-input__inner{
    border: 1px solid #DCDFE6;
    background-color:#F5F7FA !important;
} */
.login_item {
  margin-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/view/Login.vue